module.exports = __webpack_public_path__ + "5863fd422429409efe2e685f2fb6e6dd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-8.png
// module id = 2177
// module chunks = 0